import {compact} from "@pg-mono/nodash";

import {PRICES_HUB_HERO_CITY_SLUGS} from "../constants/prices_hub_cities";
import {getCitiesData} from "../utils/get_cities_data";

export interface IPricesHubHeroCity {
    slug: string;
    name: string;
    avgPriceM2: number;
    yearToYearPercent: number | null;
}

export const usePricesHubHeroCities = (): IPricesHubHeroCity[] => {
    const citiesData = getCitiesData();

    return compact(
        PRICES_HUB_HERO_CITY_SLUGS.map((slug): IPricesHubHeroCity | null => {
            const cityData = citiesData.find((city) => city.slug === slug);

            if (!cityData || !(cityData.avgPriceM2 > 0)) {
                return null;
            }

            const yearToYearPercent =
                cityData.oldAvgPriceM2 > 0 ? Math.round(((cityData.avgPriceM2 - cityData.oldAvgPriceM2) / cityData.oldAvgPriceM2) * 1000) / 10 : null;

            return {
                slug,
                name: cityData.city,
                avgPriceM2: cityData.avgPriceM2,
                yearToYearPercent: yearToYearPercent !== null && Number.isFinite(yearToYearPercent) ? yearToYearPercent : null
            };
        })
    );
};
import {compact} from "@pg-mono/nodash";

import {PRICES_HUB_HERO_CITY_SLUGS} from "../constants/prices_hub_cities";
import {getCitiesData} from "../utils/get_cities_data";

export interface IPricesHubHeroCity {
    slug: string;
    name: string;
    avgPriceM2: number;
    yearToYearPercent: number | null;
}

export const usePricesHubHeroCities = (): IPricesHubHeroCity[] => {
    const citiesData = getCitiesData();

    return compact(
        PRICES_HUB_HERO_CITY_SLUGS.map((slug): IPricesHubHeroCity | null => {
            const cityData = citiesData.find((city) => city.slug === slug);

            if (!cityData || !(cityData.avgPriceM2 > 0)) {
                return null;
            }

            const yearToYearPercent =
                cityData.oldAvgPriceM2 > 0 ? Math.round(((cityData.avgPriceM2 - cityData.oldAvgPriceM2) / cityData.oldAvgPriceM2) * 1000) / 10 : null;

            return {
                slug,
                name: cityData.city,
                avgPriceM2: cityData.avgPriceM2,
                yearToYearPercent: yearToYearPercent !== null && Number.isFinite(yearToYearPercent) ? yearToYearPercent : null
            };
        })
    );
};
